window.addEventListener('DOMContentLoaded', () => {
    let carouselsContainer = document.getElementsByClassName('carousel-container')
    initCarousels(carouselsContainer)
})
function initCarousels(carouselsContainer) {
    let nbCarousel = carouselsContainer.length
    for (let i = 0; i < nbCarousel; i++) {
        initCarousel(carouselsContainer[i],i)
    }
}
function initCarousel(container,id) {
    let lastX = 0
    let delta = 0
    let inMoove = false
    let isDragging = false
    const arrowLeft = container.getElementsByClassName('arrow-left')[0]
    const arrowRight = container.getElementsByClassName('arrow-right')[0]
    const containerItems = container.getElementsByClassName('carousel-item')
    const carouselDot = document.getElementsByClassName('carousel-dot')[id]

    initCarouselDot(container,carouselDot)
    showHiddeArrow(container, arrowLeft, arrowRight)
    arrowHight(containerItems[0], arrowLeft, arrowRight)
    showHiddeCarouselDot(window.innerWidth, carouselDot, arrowLeft, arrowRight,container)

    const handleClick = (event) => {
      event.preventDefault();
      if(delta === 0 && !inMoove) {
          window.location.href = event.target.parentNode.getAttribute('href');
      }
    };
    for (let i = 0; i < containerItems.length; i++) {
        containerItems[i].addEventListener('click', handleClick)
    }
    arrowRight.addEventListener('click', () => {
        container.scroll({
        left: container.scrollLeft + container.offsetWidth,
        behavior: 'smooth'
        })
        showHiddeArrow(container, arrowLeft, arrowRight)
    })
    arrowLeft.addEventListener('click', () => {
        container.scroll({
        left: container.scrollLeft - container.offsetWidth,
        behavior: 'smooth'
        })
    })
    container.addEventListener('scroll', () => {
        showHiddeArrow(container, arrowLeft, arrowRight)
    })
    container.addEventListener('mousedown', (event) => {
        inMoove = false
        isDragging = true
        lastX = event.clientX
        event.preventDefault()
    })
    container.addEventListener('mouseup', () => {
        isDragging = false
    })
    container.addEventListener('mousemove', () => {
        if (isDragging) {
            delta = event.clientX - lastX
            container.scrollLeft -= delta
            lastX = event.clientX
            inMoove = true
        }
    })
    container.addEventListener('click', () => {
        if (delta !== 0) {
            delta = 0
        }
    })
    container.addEventListener('mouseout', () => {
      isDragging = false
    })

    window.addEventListener('resize', () => {
        showHiddeCarouselDot(window.innerWidth, carouselDot, arrowLeft, arrowRight,container)
        arrowHight(containerItems[0], arrowLeft, arrowRight)
    })
}
function initCarouselDot(container,carouselDot) {
    carouselDot.innerHTML = ''
    let nbSlide = Math.ceil(container.getElementsByClassName('carousel-item').length/3)
    for (let i = 0; i < nbSlide; i++) {
        let dot = document.createElement('i')
        dot.classList.add('dot')
        dot.setAttribute('data-index', (i+1).toString())
        dot.addEventListener('click', () => {
            container.scroll({
                    left: container.offsetWidth * i,
                    behavior: 'smooth'
                })
        })
        carouselDot.appendChild(dot)
    }
}
function showHiddeArrow(container, arrowLeft, arrowRight) {
    if (container.scrollLeft === 0) {
        arrowLeft.style.visibility = 'hidden'
    } else {
        arrowLeft.style.visibility = 'visible'
    }
    if (container.scrollLeft === container.scrollWidth - container.offsetWidth) {
        arrowRight.style.visibility = 'hidden'
    } else {
        arrowRight.style.visibility = 'visible'
    }
}
function arrowHight(containerItem, arrowLeft, arrowRight) {
    let maxHight = containerItem.offsetHeight
    arrowLeft.style.height = maxHight + 'px'
    arrowRight.style.height = maxHight + 'px'
}
function showHiddeCarouselDot(screenWidth, carouselDot, arrowLeft, arrowRight,container) {
    if (screenWidth < 768) {
        carouselDot.style.visibility = 'visible'
        arrowLeft.style.visibility = 'hidden'
        arrowRight.style.visibility = 'hidden'
    } else {
        carouselDot.style.visibility = 'hidden'
        showHiddeArrow(container, arrowLeft, arrowRight)
    }
}
